import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson establishes London Rubber Company and sells imported barber condoms and accessories.',
		},
		{
			year: 1929,
			description: 'The London Rubber Company (LRC) has the Durex® brand registered.',
		},
		{
			year: '1950s',
			description: 'Durex launches its first moistened condom',
		},
		{
			year: 1953,
			description: 'Durex is the first brand to develop and use electronic testing',
		},
		{
			year: '1960s',
			description: 'Durex launches the first anatomically shaped condom',
		},
		{
			year: '1970s',
			description: 'Durex is the first condom brand in the world to advertise in many countries',
		},
		{
			year: '1990s',
			description: 'Durex is the first <a href="/explore-sex/all-articles/condom/">condom</a> brand to adopt a Global "quality seal" as standard',
		},
		{
			year: 1995,
			description: 'Durex launches a range of colourful and flavoured condoms',
		},
		{
			year: 1996,
			description: 'Durex is the first condom brand to set up a website. We now have 42 different websites for the countries in which we are represented.',
		},
		{
			year: 1997,
			description: 'Durex launches latex-free condoms. A new, non-allergenic material is used for the new product: the synthetic polyurethane developed by Durex is softer and more elastic than natural rubber latex',
		},
		{
			year: 1998,
			description: 'Durex launches the first anatomically shaped condom',
		},
		{
			year: 2001,
			description: 'Durex introduces Pleasuremax. This makes Durex the first condom brand to market a condom that is both ribbed and dotted.',
		},
		{
			year: 2003,
			description: 'Durex launches an exciting range of Play Lubricants.',
		},
		{
			year: 2005,
			description: 'Durex Network launches the Face of Global Sex reports, which explore aspects of sexual behaviour and are created for the information of academics and policy makers.',
		},
		{
			year: 2008,
			description: 'To promote safe sex among young people, Durex encourages young people between the ages of 16 and 24 to create a unique poster on sexual health - a poster of adolescents for teens.',
		},
		{
			year: 2009,
			description: 'Durex turns 80',
		},
		{
			year: 2010,
			description: 'Durex supports the initiative "Condomize!" of the United Nations Population Fund at the International AIDS Conference in Vienna through a donation of 220,000 condoms.',
		},
		{
			year: 2010,
			description: 'Durex is bought by Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'Durex introduces Performax Intense, a condom designed to assist in cumming together. With 5% benzocaine-containing inner coating and stimulating outer structure, it can help for longer and more intense sex.',
		},
		{
			year: 2019,
			description: 'Durex turns 90!',
		},
	]
}